import { render, staticRenderFns } from "./privacy-management-detail.vue?vue&type=template&id=72ba328a&scoped=true&"
import script from "./privacy-management-detail.vue?vue&type=script&lang=js&"
export * from "./privacy-management-detail.vue?vue&type=script&lang=js&"
import style0 from "./privacy-management-detail.vue?vue&type=style&index=0&id=72ba328a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba328a",
  null
  
)

export default component.exports